module.exports = __webpack_public_path__ + "static/PSA6-c737c0679961ac63ddaf152826dde7dd.png";